import { atom } from "recoil";
import { recoilPersist } from 'recoil-persist'



const { persistAtom } = recoilPersist()

const districtAdminState = atom({
  key: "district_admin_v1",
  default: {
    fName: null,
    userId: null,
    email: null,
    token: null,
    lName: null,
    districtId:null
  },
  
  effects_UNSTABLE: [persistAtom]
});


const setDistrictCookie = (obj) => {
  let ___cookies = getCookie('recoil-persist')
  let _cookies = JSON.parse(___cookies)
  var exdate=new Date();
  exdate.setDate(exdate.getDate() + 7);
  if (_cookies) {
    _cookies['district_admin_v1'] = obj
    document.cookie = `recoil-persist=${JSON.stringify(_cookies)};path=/;expires=${exdate.toUTCString()}`
  }
  else {
    document.cookie = `recoil-persist=${JSON.stringify({ district_admin_v1: obj })};path=/;expires=${exdate.toUTCString()}`
  }
}


function getCookie(name) {
  var cookieArr = document.cookie.split(";");
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");
    if (name === cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

export default getCookie;

export {districtAdminState, getCookie, setDistrictCookie};